import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Link from 'react-router/lib/Link';
import { injectIntl, defineMessages } from 'react-intl';
import { decorateIntlMessages } from '../common/rosetta_formatted_message';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';
import { getRelativePath } from '../../utils/url';
import toSentence from '../../utils/toSentence';
import {map} from 'lodash';

const messages = decorateIntlMessages(__filename, defineMessages({
  separator: {
    id: 'separator',
    description: 'Separator for main contributors',
    defaultMessage: ', '
  }
}));

export class Contributor extends PureComponent {

  handleClick = () => {
    sendAnalyticsEvent(
      'Contributor',
      'Click',
      this.props.name
    );

    sendDataLayerEvent('Click', {
      pageModule: 'Header',
      linkType: 'contributor',
      linkTitle: this.props.name,
      linkHeadline: this.props.name,
      // linkUID: '', id of contributor is not in the API
      linkURL: this.props.path,
      itemName: this.props.name
    });
  };

  render() {
    const { name, path } = this.props;
    const { edition_data } = this.context;
    return (
      <span className="contributor" key={name}>
        <Link
          to={getRelativePath(path, edition_data)}
          onClick={this.handleClick}
          dangerouslySetInnerHTML={{ __html: name }}
        />
      </span>
    );
  }
}

Contributor.propTypes = {
  name: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired
};

Contributor.contextTypes = {
  edition_data: PropTypes.object
};

const Contributors = ({ contributors, intl: { formatMessage } }) => (
  <div className="byline main-contributors">
    {
      toSentence(map(contributors, ({ name, path }) => (
        <Contributor name={name} path={path} key={path} />
      )), {
        separator: formatMessage(messages.separator)
      })
    }
  </div>
);

Contributors.propTypes = {
  contributors: PropTypes.arrayOf(
    PropTypes.shape(
      Contributor.propTypes
    ).isRequired
  ).isRequired,
  intl: PropTypes.object.isRequired
};

export default injectIntl(Contributors);
